// extracted by mini-css-extract-plugin
export default {"home-scream":"Card_home-scream__nvypD","profile-scream":"Card_profile-scream__EaDGr","random-user-scream":"Card_random-user-scream__3-DYG","profile":"Card_profile__-uLpZ"};